import type { TokenHandshakeHandler } from './types'
import { clearTokenHandshakeCompleted, clearTokenHandshakeSession } from '../token-handshake'

export const logoutHandler: TokenHandshakeHandler = async (_params, { authStore }) => {
	clearTokenHandshakeCompleted()
	clearTokenHandshakeSession()
	await authStore.logout(false)

	return {
		result: 1
	}
}
